import { useMemo } from "react";
import { useGetTaskTypeQuery, useGetTaskTypesQuery } from "./taskTypeEndpoints";
import { TaskType } from "../../entities/taskType";

export function useTaskType(taskTypeID: number | undefined) {
  const taskTypeQuery = useGetTaskTypeQuery(taskTypeID ?? 0, {
    skip: (taskTypeID ?? 0) <= 0,
  });
  const taskTypeEntity = taskTypeQuery.data;

  return useMemo(() => {
    const ret: typeof taskTypeQuery & { taskType?: TaskType | undefined } = {
      ...taskTypeQuery,
    };
    if (taskTypeEntity) ret.taskType = new TaskType(taskTypeEntity);
    return ret;
  }, [taskTypeEntity]);
}

export function useTaskTypes() {
  const taskTypeQuery = useGetTaskTypesQuery();
  const taskTypeEntitiesMap = taskTypeQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof taskTypeQuery & {
      taskTypes?: TaskType[];
      taskTypesMap?: { [id: number]: TaskType };
    } = {
      ...taskTypeQuery,
      taskTypes: [],
      taskTypesMap: {},
    };
    if (taskTypeEntitiesMap) {
      const taskTypes: TaskType[] = [];
      const taskTypesMap: { [id: number]: TaskType } = {};

      for (const key in taskTypeEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(taskTypeEntitiesMap, key)) {
          const c = taskTypeEntitiesMap[key];
          const taskType = new TaskType(c);
          taskTypes.push(taskType);
          taskTypesMap[taskType.id] = taskType;
        }
      }
      ret.taskTypes = taskTypes;
      ret.taskTypesMap = taskTypesMap;
    }

    return ret;
  }, [taskTypeEntitiesMap]);
}
